export enum AIConvoContextType {
    HOME = 'HOME',
    DASHBOARD = 'DASHBOARD',
    COMMUNITY = 'COMMUNITY',
    POST = 'POST',
}

export type AIConvoContext =
    | { type: AIConvoContextType.HOME }
    | { type: AIConvoContextType.DASHBOARD }
    | { type: AIConvoContextType.COMMUNITY; communityId: number }
    | { type: AIConvoContextType.POST; postId: number; communityId: number };

/**
 * Deliberately closed: only the context types that should show the
 * "search in community X" chip. A new AIConvoContextType stays out
 * until someone explicitly adds it here.
 */
export const AI_CONVO_FILTER_CHIP_CONTEXT_TYPES: ReadonlySet<AIConvoContextType> =
    new Set([
        AIConvoContextType.HOME,
        AIConvoContextType.DASHBOARD,
        AIConvoContextType.COMMUNITY,
    ]);
